module.exports = __webpack_public_path__ + "img/pocket-3_en.93d702b.jpg";